module.exports = __webpack_public_path__ + "490e5385d329b9d3fbe875b8ad0be8f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/hero/app-marketplace-hero_desktop@2x.svg
// module id = 2445
// module chunks = 0